<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" md="12">
        <div class="pa-2" v-if="'name' in inventory.body">
          <p class="default_txt">Name</p>
          <v-text-field
            v-model="inventory.body.name"
            dense
            placeholder="Type Here"
            hide-details
            color="green"
          ></v-text-field>
        </div>
        <div class="pa-2" v-if="'title' in inventory.body">
          <p class="default_txt">Title</p>
          <v-text-field
            v-model="inventory.body.title"
            dense
            placeholder="Type Here"
            hide-details
            color="green"
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <div class="d-flex justify-end">
      <v-btn
        depressed
        color="var(--g)"
        dark
        class="text-capitalize"
        @click="postData"
        >Save</v-btn
      >
    </div>
    <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
      <v-progress-circular
        indeterminate
        class="mr-2"
        color="#006341"
      ></v-progress-circular>
      <b class="color_default">Loading...</b>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "createupsector",
  props: ["inventory"],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    postData() {
      this.loading = true;

      let data = {
        path: this.inventory.path,
        body: this.inventory.body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          for (let i in this.inventory.body) {
            this.inventory.body[i] = "";
          }
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("success");
        })
        .catch((e) => {
          if (e.data) {
            var key = Object.keys(e.data.errors);
            var values = Object.values(e.data.errors);
            for (let i = 0; i < key.length; i++) {
              for (let j = 0; j < values[i].length; j++) {
                this.$toast.error(values[i][j]);
              }
            }
          } else {
            this.$store.dispatch("notify", {
              msg: e.message,
              type: "error",
            });
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
